import React, { useEffect } from 'react'
import {
  Text,
  withSitecoreContext,
  RichText,
  isEditorActive,
  Link
} from '@sitecore-jss/sitecore-jss-react'
import '../../styles/@shared/rte.scss'

import { EventsModel } from './models/Events.model'
import { EventsProps } from './types/Events.types'
import { anchorWithId } from '../../helpers/anchorWithId.helper'

const convertFileSize = (sizeInBytes) => {
  if (sizeInBytes) {
    const fielSize = (sizeInBytes / (1024 * 1024)).toFixed(2)
    const fielSizeNumber = parseInt(fielSize)
    if (fielSizeNumber < 1) {
      return (sizeInBytes / 1024).toFixed(2) + ' ' + ' KB'
    } else return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' ' + 'MB'
  }
}

const Events = (props: EventsProps) => {
  const eventListItems = props.fields?.EventGroups
  const EventsTitle = props.fields?.Title
  const TwoColumns = props.fields?.['Two Columns'];
  const numberOfDoc = props.fields?.EventGroups?.filter((x) => x).length ?? 0;
  const numberOfDocMinusOne = numberOfDoc - 1
  const slicedArr1Length =
    numberOfDoc % 2 == 0 && numberOfDoc > 1
      ? numberOfDoc / 2
      : !(numberOfDoc % 2 == 0) && numberOfDoc > 1
      ? numberOfDoc - numberOfDocMinusOne / 2
      : numberOfDoc;
  const firstArr = eventListItems?.slice(0, slicedArr1Length)
  const secondArr = eventListItems?.slice(slicedArr1Length, numberOfDoc)

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  /* modify with field */

  const PDFIcon = 'cnh-arrow-forward' //field
  const IMGIcon = 'cnh-arrow-forward' //field
  const ZIPIcon = 'cnh-arrow-forward' //field

  const IsPDFIcon = true //field
  const IsIMGIcon = true //field
  const IsZIPIcon = true //field

  const DateField = '' //field & put inline
  const LinkFieldPDF = 'EventPage' //field
  const LinkFieldIMG = 'EventPage' //field
  const LinkFieldZIP = 'EventPage' //field

  return (
    <>
      {props.fields && (
        <div className="rte-event" id={props?.rendering?.uid}>
          <div>
            <RichText
              field={EventsTitle}
              className="rte-event-heading"
              tag="h2"
            />

            {TwoColumns &&
            props.fields?.EventGroups &&
            props.fields?.EventGroups?.length > 0 ? (
              <div
                className="rte-event-firstSecondArr"
                style={{
                  gridTemplateRows: `repeat(${slicedArr1Length}, auto)`,
                }}
              >
                {firstArr?.map((item, index: number) => (
                  <div
                    key={index}
                    className={`rte-event-list rte-event-listBKTwoA ${
                      TwoColumns
                        ? 'rte-event-list--split-two'
                        : 'rte-event-list--keep-one'
                    }`}
                  >
                    <div className="rte-event-list-right">
                      <div className="rte-event-list-header-wrapper">
                        <div className="rte-event-list-header left">
                          {/* modify with field */}
                          {DateField ||
                            (DateField.length !== 0 && (
                              <div className="rte-event-list-heading-left">
                                {DateField}
                              </div>
                            ))}

                          <RichText
                            field={item.fields?.EventTitle}
                            className="rte-event-list-heading"
                            tag="h3"
                          />
                        </div>
                        <div
                          className={`rte-event-list-header right ${
                            item?.fields?.EventPage?.value.href ||
                            item?.fields?.DocumentLink?.value?.src
                              ? ''
                              : 'hideEventHeader'
                          }`}
                        >
                          {/* modify with field */}
                          {(item?.fields?.[`${LinkFieldPDF}`]?.value?.href && //adjust search with new fields
                            item?.fields?.[`${LinkFieldPDF}`]?.value?.href?.length !== 0 &&
                            ((item.fields?.DocumentLink?.value?.extension &&
                              item.fields?.DocumentLink?.value?.extension
                                .length !== 0) ||
                              (PDFIcon && PDFIcon.length !== 0))) ||
                            (item?.fields?.[`${LinkFieldIMG}`]?.value.href &&
                              item?.fields[`${LinkFieldIMG}`]?.value?.href?.length !== 0 &&
                              ((item.fields?.DocumentLink?.value?.extension &&
                                item.fields?.DocumentLink?.value?.extension
                                  .length !== 0) ||
                                (IMGIcon && IMGIcon.length !== 0))) ||
                            (item?.fields?.[`${LinkFieldZIP}`]?.value?.href &&
                              item?.fields?.[`${LinkFieldZIP}`]?.value?.href?.length !== 0 &&
                              ((item.fields?.DocumentLink?.value?.extension &&
                                item.fields?.DocumentLink?.value?.extension
                                  .length !== 0) ||
                                (ZIPIcon && ZIPIcon.length !== 0)) && (
                                <div
                                  className={` ${
                                    TwoColumns
                                      ? 'rte-event-list-heading-grandfather rte-event-list-heading-grandfather-twoc'
                                      : 'rte-event-list-heading-grandfather'
                                  }`}
                                >
                                  {item?.fields?.[`${LinkFieldPDF}`]?.value?.href &&
                                    item?.fields?.[`${LinkFieldPDF}`]?.value?.href?.length !== 0 && (
                                      <div
                                        className={`rte-event-list-heading-father ${
                                          IsPDFIcon &&
                                          'rte-event-list-heading-father--icon'
                                        }`}
                                      >
                                        <a
                                          className="rte-event-list-heading-left"
                                          download
                                          href={anchorWithId(
                                            item?.fields?.[`${LinkFieldPDF}`]?.value?.href ?? '',
                                            item.fields[`${LinkFieldPDF}`]
                                              ?.value.anchor
                                          )}
                                          target={
                                            item.fields[`${LinkFieldPDF}`]
                                              ?.value?.target &&
                                            item.fields[`${LinkFieldPDF}`]
                                              ?.value?.target !== ''
                                              ? item.fields[`${LinkFieldPDF}`]
                                                  ?.value?.target
                                              : '_blank'
                                          }
                                        >
                                          {IsPDFIcon ? (
                                            <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                              <pfe-icon
                                                icon={PDFIcon}
                                                size={'24'}
                                                color={'complement'}
                                              />
                                            </span>
                                          ) : (
                                            <Text
                                              field={{
                                                value:
                                                  item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldPDF}`])
                                              }}
                                              tag="p"
                                              className="rte-event-list-heading-left"
                                            />
                                          )}
                                        </a>
                                        <Text
                                          field={{
                                            value: convertFileSize(
                                              item.fields?.DocumentLink?.value
                                                ?.size // field ([`${LinkFieldPDF}`])
                                            ),
                                          }}
                                          tag="p"
                                          className="rte-event-list-heading-left"
                                        />
                                      </div>
                                    )}

                                  {item.fields[`${LinkFieldIMG}`]?.value.href &&
                                    item.fields[`${LinkFieldIMG}`]?.value.href?.length !== 0 && (
                                      <div
                                        className={`rte-event-list-heading-father ${
                                          IsIMGIcon &&
                                          'rte-event-list-heading-father--icon'
                                        }`}
                                      >
                                        <a
                                          className="rte-event-list-heading-left"
                                          download
                                          href={anchorWithId(
                                            item.fields?.[`${LinkFieldIMG}`]?.value.href ?? '',
                                            item.fields[`${LinkFieldIMG}`]
                                              ?.value.anchor
                                          )}
                                          target={
                                            item.fields[`${LinkFieldIMG}`]
                                              ?.value?.target &&
                                            item.fields[`${LinkFieldIMG}`]
                                              ?.value?.target !== ''
                                              ? item.fields[`${LinkFieldIMG}`]
                                                  ?.value?.target
                                              : '_blank'
                                          }
                                        >
                                          {IsIMGIcon ? (
                                            <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                              <pfe-icon
                                                icon={IMGIcon}
                                                size={'24'}
                                                color={'complement'}
                                              />
                                            </span>
                                          ) : (
                                            <Text
                                              field={{
                                                value:
                                                  item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldIMG}`])
                                              }}
                                              tag="p"
                                              className="rte-event-list-heading-left"
                                            />
                                          )}
                                        </a>
                                        <Text
                                          field={{
                                            value: convertFileSize(
                                              item.fields?.DocumentLink?.value
                                                ?.size // field ([`${LinkFieldIMG}`])
                                            ),
                                          }}
                                          tag="p"
                                          className="rte-event-list-heading-left"
                                        />
                                      </div>
                                    )}

                                  {item.fields[`${LinkFieldZIP}`]?.value.href &&
                                    item.fields[`${LinkFieldZIP}`]?.value.href?.length !== 0 && (
                                      <div
                                        className={`rte-event-list-heading-father ${
                                          IsZIPIcon &&
                                          'rte-event-list-heading-father--icon'
                                        }`}
                                      >
                                        <a
                                          className="rte-event-list-heading-left"
                                          download
                                          href={anchorWithId(
                                            item.fields?.[`${LinkFieldZIP}`]?.value?.href ?? '',
                                            item.fields[`${LinkFieldZIP}`]
                                              ?.value.anchor
                                          )}
                                          target={
                                            item.fields[`${LinkFieldZIP}`]
                                              ?.value?.target &&
                                            item.fields[`${LinkFieldZIP}`]
                                              ?.value?.target !== ''
                                              ? item.fields[`${LinkFieldZIP}`]
                                                  ?.value?.target
                                              : '_blank'
                                          }
                                        >
                                          {IsZIPIcon ? (
                                            <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                              <pfe-icon
                                                icon={ZIPIcon}
                                                size={'24'}
                                                color={'complement'}
                                              />
                                            </span>
                                          ) : (
                                            <Text
                                              field={{
                                                value:
                                                  item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldZIP}`])
                                              }}
                                              tag="p"
                                              className="rte-event-list-heading-left"
                                            />
                                          )}
                                        </a>
                                        <Text
                                          field={{
                                            value: convertFileSize(
                                              item.fields?.DocumentLink?.value
                                                ?.size // field ([`${LinkFieldZIP}`])
                                            ),
                                          }}
                                          tag="p"
                                          className="rte-event-list-heading-left"
                                        />
                                      </div>
                                    )}
                                </div>
                              ))}

                          {item?.fields?.EventPage?.value.href ? (
                            <p className="read-more-link">
                              {isEditorActive() ? (
                                <Link
                                  field={item.fields.EventPage}
                                />
                              ) : (
                                <Link
                                  target={
                                    item?.fields?.linktarget?.value &&
                                    item.fields.linktarget.value !== ''
                                      ? item.fields.linktarget.value
                                      : '_blank'
                                  }
                                  field={{
                                    value: item.fields.EventPage?.value?.href,
                                  }}
                                  href={anchorWithId(
                                    item.fields.EventPage?.value?.href,
                                    item.fields.EventPage?.value?.anchor
                                  )}
                                >
                                  <Text
                                    field={{
                                      value: item.fields.EventPage?.value.text,
                                    }}
                                    tag="span"
                                  />
                                  <span className="link-with-arrow link-with-arrow--text">
                                    <pfe-icon
                                      icon="cnh-arrow-forward"
                                      size={'24'}
                                      color={'complement'}
                                    />
                                  </span>
                                </Link>
                              )}
                            </p>
                          ) : null}
                          {/* {item.fields.DocumentLink?.value?.src ? (
                            <>
                              {isEditorActive() ? (
                                <Link
                                  field={item.fields?.DocumentLink}
                                />
                              ) : (
                                <div className="PDF-File">
                                  <Text
                                    className="file-size"
                                    field={{
                                      value: convertFileSize(
                                        item.fields?.DocumentLink?.value?.size
                                      ),
                                    }}
                                    tag="p"
                                  />
                                  <p className="link">
                                    <Link
                                      target={
                                        item?.fields?.linktarget?.value &&
                                        item?.fields?.linktarget?.value !== ""
                                          ? item?.fields?.linktarget?.value
                                          : "_blank"
                                      }
                                      field={{
                                        value:
                                          item.fields?.DocumentLink?.value?.src,
                                      }}
                                      href={anchorWithId(
                                        item.fields?.DocumentLink?.value?.src,
                                        item.fields?.DocumentLink?.value?.anchor
                                      )}
                                    >
                                      <Text
                                        field={{
                                          value:
                                            item.fields?.DocumentLink?.value?.extension.toUpperCase(),
                                        }}
                                        tag="span"
                                      />
                                      <span className="link-with-arrow link-with-arrow--text">
                                        <pfe-icon
                                          icon="cnh-download"
                                          size={"24"}
                                          color={"complement"}
                                        />
                                      </span>
                                    </Link>
                                  </p>
                                </div>
                              )}
                            </>
                          ) : null} */}
                        </div>
                      </div>
                      {(item.fields?.Events?.length ?? 0) > 0 && (
                        <div className="rte-event-list-container">
                          {item.fields?.Events?.map((item, index: number) => (
                            <div className="rte-event-list-row" key={index}>
                              <div className={`rte-event-list-column left `}>
                                <RichText field={item.fields?.Name} tag="span" />
                              </div>

                              {/* READ MORE LINK */}
                              <div className="rte-event-list-column right">
                                {item.fields?.ReadMoreLink?.value.href ? (
                                  <p className="read-more-link">
                                    {isEditorActive() ? (
                                      <Link
                                        field={item.fields.ReadMoreLink}
                                      />
                                    ) : (
                                      <Link
                                        field={{
                                          value:
                                            item.fields.ReadMoreLink?.value
                                              ?.href,
                                        }}
                                        href={anchorWithId(
                                          item.fields.ReadMoreLink?.value?.href,
                                          item.fields.ReadMoreLink?.value
                                            ?.anchor
                                        )}
                                        target={
                                          item?.fields?.linktarget?.value &&
                                          item?.fields?.linktarget?.value !== ''
                                            ? item?.fields?.linktarget?.value
                                            : '_blank'
                                        }
                                      >
                                        <Text
                                          field={{
                                            value:
                                              item.fields.ReadMoreLink?.value
                                                .text,
                                          }}
                                          tag="span"
                                        />
                                        <span className="link-with-arrow link-with-arrow--text">
                                          <pfe-icon
                                            icon="cnh-arrow-forward"
                                            size={'24'}
                                            color={'complement'}
                                          />
                                        </span>
                                      </Link>
                                    )}
                                  </p>
                                ) : null}
                                {/* WEBCAST LINK */}
                                {item.fields?.WebCastLink?.value.href ? (
                                  <p className="link">
                                    {isEditorActive() ? (
                                      <Link
                                        field={item.fields.WebCastLink}
                                      />
                                    ) : (
                                      <Link
                                        field={{
                                          value:
                                            item.fields.WebCastLink?.value
                                              ?.href,
                                        }}
                                        href={anchorWithId(
                                          item.fields.WebCastLink?.value?.href,
                                          item.fields.WebCastLink?.value?.anchor
                                        )}
                                        rel="noopener noreferrer"
                                        target={
                                          item?.fields?.linktarget?.value &&
                                          item?.fields?.linktarget?.value !== ''
                                            ? item?.fields?.linktarget?.value
                                            : '_blank'
                                        }
                                      >
                                        <Text
                                          field={{
                                            value:
                                              item.fields.WebCastLink?.value
                                                .text,
                                          }}
                                          tag="span"
                                        />
                                        <span className="link-with-arrow link-with-arrow--text">
                                          <pfe-icon
                                            icon="cnh-external-link"
                                            size={'24'}
                                            color={'complement'}
                                          />
                                        </span>
                                      </Link>
                                    )}
                                  </p>
                                ) : null}
                                {/* {item.fields.DocumentLink?.value?.src ? (
                                  <>
                                    {isEditorActive() ? (
                                      <Link
                                        field={item.fields?.DocumentLink}
                                      />
                                    ) : (
                                      <div className="PDF-File">
                                        <Text
                                          className="file-size"
                                          field={{
                                            value: convertFileSize(
                                              item.fields?.DocumentLink?.value
                                                ?.size
                                            ),
                                          }}
                                          tag="p"
                                        />
                                        <p className="link">
                                          <Link
                                            target={
                                              item?.fields?.linktarget?.value &&
                                              item?.fields?.linktarget
                                                ?.value !== ""
                                                ? item?.fields?.linktarget
                                                    ?.value
                                                : "_blank"
                                            }
                                            field={{
                                              value:
                                                item.fields?.DocumentLink?.value
                                                  ?.src,
                                            }}
                                            href={anchorWithId(
                                              item.fields?.DocumentLink?.value
                                                ?.src,
                                              item.fields?.DocumentLink?.value
                                                ?.anchor
                                            )}
                                          >
                                            <Text
                                              field={{
                                                value:
                                                  item.fields?.DocumentLink?.value?.extension.toUpperCase(),
                                              }}
                                              tag="span"
                                            />
                                            <span className="link-with-arrow link-with-arrow--text">
                                              <pfe-icon
                                                icon="cnh-download"
                                                size={"24"}
                                                color={"complement"}
                                              />
                                            </span>
                                          </Link>
                                        </p>
                                      </div>
                                    )}
                                  </>
                                ) : null} */}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                {numberOfDoc > 1 &&
                  secondArr?.map((item, index: number) => (
                    <div
                      key={index}
                      className={`rte-event-list ${
                        slicedArr1Length % 2
                          ? 'rte-event-listBKTwoB'
                          : 'rte-event-listBKTwoBB'
                      } ${
                        TwoColumns
                          ? 'rte-event-list--split-two'
                          : 'rte-event-list--keep-one'
                      }`}
                    >
                      <div className="rte-event-list-right">
                        <div className="rte-event-list-header-wrapper">
                          <div className="rte-event-list-header left">
                            {/* modify with field */}
                            {DateField ||
                              (DateField.length !== 0 && (
                                <div className="rte-event-list-heading-left">
                                  {DateField}
                                </div>
                              ))}

                            <RichText
                              field={item.fields?.EventTitle}
                              className="rte-event-list-heading"
                              tag="h3"
                            />
                          </div>
                          <div
                            className={`rte-event-list-header right ${
                              item.fields?.EventPage?.value.href ||
                              item.fields?.DocumentLink?.value?.src
                                ? ''
                                : 'hideEventHeader'
                            }`}
                          >
                            {/* modify with field */}
                            {(item.fields?.[`${LinkFieldPDF}`]?.value.href && //adjust search with new fields
                              item.fields?.[`${LinkFieldPDF}`]?.value.href?.length !== 0 &&
                              ((item.fields?.DocumentLink?.value?.extension &&
                                item.fields?.DocumentLink?.value?.extension
                                  .length !== 0) ||
                                (PDFIcon && PDFIcon.length !== 0))) ||
                              (item.fields?.[`${LinkFieldIMG}`]?.value.href &&
                                item.fields[`${LinkFieldIMG}`]?.value.href?.length !== 0 &&
                                ((item.fields?.DocumentLink?.value?.extension &&
                                  item.fields?.DocumentLink?.value?.extension
                                    .length !== 0) ||
                                  (IMGIcon && IMGIcon.length !== 0))) ||
                              (item?.fields?.[`${LinkFieldZIP}`]?.value.href &&
                                item.fields[`${LinkFieldZIP}`]?.value.href?.length !== 0 &&
                                ((item.fields?.DocumentLink?.value?.extension &&
                                  item.fields?.DocumentLink?.value?.extension
                                    .length !== 0) ||
                                  (ZIPIcon && ZIPIcon.length !== 0)) && (
                                  <div
                                    className={` ${
                                      TwoColumns
                                        ? 'rte-event-list-heading-grandfather rte-event-list-heading-grandfather-twoc'
                                        : 'rte-event-list-heading-grandfather'
                                    }`}
                                  >
                                    {item.fields[`${LinkFieldPDF}`]?.value?.href &&
                                      item.fields[`${LinkFieldPDF}`]?.value.href?.length !== 0 && (
                                        <div
                                          className={`rte-event-list-heading-father ${
                                            IsPDFIcon &&
                                            'rte-event-list-heading-father--icon'
                                          }`}
                                        >
                                          <a
                                            className="rte-event-list-heading-left"
                                            download
                                            href={anchorWithId(
                                              item?.fields?.[`${LinkFieldPDF}`]?.value?.href ?? '',
                                              item.fields[`${LinkFieldPDF}`]
                                                ?.value.anchor
                                            )}
                                            target={
                                              item.fields[`${LinkFieldPDF}`]
                                                ?.value?.target &&
                                              item.fields[`${LinkFieldPDF}`]
                                                ?.value?.target !== ''
                                                ? item.fields[`${LinkFieldPDF}`]
                                                    ?.value?.target
                                                : '_blank'
                                            }
                                          >
                                            {IsPDFIcon ? (
                                              <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                                <pfe-icon
                                                  icon={PDFIcon}
                                                  size={'24'}
                                                  color={'complement'}
                                                />
                                              </span>
                                            ) : (
                                              <Text
                                                field={{
                                                  value:
                                                    item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldPDF}`])
                                                }}
                                                tag="p"
                                                className="rte-event-list-heading-left"
                                              />
                                            )}
                                          </a>
                                          <Text
                                            field={{
                                              value: convertFileSize(
                                                item.fields?.DocumentLink?.value
                                                  ?.size // field ([`${LinkFieldPDF}`])
                                              ),
                                            }}
                                            tag="p"
                                            className="rte-event-list-heading-left"
                                          />
                                        </div>
                                      )}

                                    {item.fields[`${LinkFieldIMG}`]?.value
                                      .href &&
                                      item.fields[`${LinkFieldIMG}`]?.value.href?.length !== 0 && (
                                        <div
                                          className={`rte-event-list-heading-father ${
                                            IsIMGIcon &&
                                            'rte-event-list-heading-father--icon'
                                          }`}
                                        >
                                          <a
                                            className="rte-event-list-heading-left"
                                            download
                                            href={anchorWithId(
                                              item.fields[`${LinkFieldIMG}`]?.value?.href ?? '',
                                              item.fields[`${LinkFieldIMG}`]
                                                ?.value.anchor
                                            )}
                                            target={
                                              item.fields[`${LinkFieldIMG}`]
                                                ?.value?.target &&
                                              item.fields[`${LinkFieldIMG}`]
                                                ?.value?.target !== ''
                                                ? item.fields[`${LinkFieldIMG}`]
                                                    ?.value?.target
                                                : '_blank'
                                            }
                                          >
                                            {IsIMGIcon ? (
                                              <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                                <pfe-icon
                                                  icon={IMGIcon}
                                                  size={'24'}
                                                  color={'complement'}
                                                />
                                              </span>
                                            ) : (
                                              <Text
                                                field={{
                                                  value:
                                                    item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldIMG}`])
                                                }}
                                                tag="p"
                                                className="rte-event-list-heading-left"
                                              />
                                            )}
                                          </a>
                                          <Text
                                            field={{
                                              value: convertFileSize(
                                                item.fields?.DocumentLink?.value
                                                  ?.size // field ([`${LinkFieldIMG}`])
                                              ),
                                            }}
                                            tag="p"
                                            className="rte-event-list-heading-left"
                                          />
                                        </div>
                                      )}

                                    {item.fields[`${LinkFieldZIP}`]?.value.href &&
                                      item.fields?.[`${LinkFieldZIP}`]?.value?.href?.length !== 0 && (
                                        <div
                                          className={`rte-event-list-heading-father ${
                                            IsZIPIcon &&
                                            'rte-event-list-heading-father--icon'
                                          }`}
                                        >
                                          <a
                                            className="rte-event-list-heading-left"
                                            download
                                            href={anchorWithId(
                                              item.fields[`${LinkFieldZIP}`]?.value?.href ?? '',
                                              item.fields[`${LinkFieldZIP}`]
                                                ?.value.anchor
                                            )}
                                            target={
                                              item.fields[`${LinkFieldZIP}`]
                                                ?.value?.target &&
                                              item.fields[`${LinkFieldZIP}`]
                                                ?.value?.target !== ''
                                                ? item.fields[`${LinkFieldZIP}`]
                                                    ?.value?.target
                                                : '_blank'
                                            }
                                          >
                                            {IsZIPIcon ? (
                                              <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                                <pfe-icon
                                                  icon={ZIPIcon}
                                                  size={'24'}
                                                  color={'complement'}
                                                />
                                              </span>
                                            ) : (
                                              <Text
                                                field={{
                                                  value:
                                                    item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldZIP}`])
                                                }}
                                                tag="p"
                                                className="rte-event-list-heading-left"
                                              />
                                            )}
                                          </a>
                                          <Text
                                            field={{
                                              value: convertFileSize(
                                                item.fields?.DocumentLink?.value
                                                  ?.size // field ([`${LinkFieldZIP}`])
                                              ),
                                            }}
                                            tag="p"
                                            className="rte-event-list-heading-left"
                                          />
                                        </div>
                                      )}
                                  </div>
                                ))}

                            {item?.fields?.EventPage?.value.href ? (
                              <p className="read-more-link">
                                {isEditorActive() ? (
                                  <Link
                                    field={item.fields.EventPage}
                                  />
                                ) : (
                                  <Link
                                    field={{
                                      value: item.fields.EventPage?.value?.href,
                                    }}
                                    href={anchorWithId(
                                      item.fields.EventPage?.value?.href,
                                      item.fields.EventPage?.value?.anchor
                                    )}
                                    target={
                                      item?.fields?.linktarget?.value &&
                                      item?.fields?.linktarget?.value !== ''
                                        ? item?.fields?.linktarget?.value
                                        : '_blank'
                                    }
                                  >
                                    <Text
                                      field={{
                                        value:
                                          item.fields.EventPage?.value.text,
                                      }}
                                      tag="span"
                                    />
                                    <span className="link-with-arrow link-with-arrow--text">
                                      <pfe-icon
                                        icon="cnh-arrow-forward"
                                        size={'24'}
                                        color={'complement'}
                                      />
                                    </span>
                                  </Link>
                                )}
                              </p>
                            ) : null}

                            {/* {item.fields.DocumentLink?.value?.src ? (
                              <>
                                {isEditorActive() ? (
                                  <Link
                                    field={item.fields?.DocumentLink}
                                  />
                                ) : (
                                  <div className="PDF-File">
                                    <Text
                                      className="file-size"
                                      field={{
                                        value: convertFileSize(
                                          item.fields?.DocumentLink?.value?.size
                                        ),
                                      }}
                                      tag="p"
                                    />
                                    <p className="link">
                                      <Link
                                        target={
                                          item?.fields?.linktarget?.value &&
                                          item?.fields?.linktarget?.value !== ""
                                            ? item?.fields?.linktarget?.value
                                            : "_blank"
                                        }
                                        field={{
                                          value:
                                            item.fields?.DocumentLink?.value
                                              ?.src,
                                        }}
                                        href={anchorWithId(
                                          item.fields?.DocumentLink?.value?.src,
                                          item.fields?.DocumentLink?.value
                                            ?.anchor
                                        )}
                                      >
                                        <Text
                                          field={{
                                            value:
                                              item.fields?.DocumentLink?.value?.extension.toUpperCase(),
                                          }}
                                          tag="span"
                                        />
                                        <span className="link-with-arrow link-with-arrow--text">
                                          <pfe-icon
                                            icon="cnh-download"
                                            size={"24"}
                                            color={"complement"}
                                          />
                                        </span>
                                      </Link>
                                    </p>
                                  </div>
                                )}
                              </>
                            ) : null} */}
                          </div>
                        </div>
                        {(item?.fields?.Events?.length ?? 0) > 0 && (
                          <div className="rte-event-list-container">
                            {item.fields?.Events?.map((item, index: number) => (
                              <div className="rte-event-list-row" key={index}>
                                <div className={`rte-event-list-column left `}>
                                  <RichText
                                    field={item?.fields?.Name}
                                    tag="span"
                                  />
                                </div>

                                {/* READ MORE LINK */}
                                <div className="rte-event-list-column right">
                                  {item.fields?.ReadMoreLink?.value.href ? (
                                    <p className="read-more-link">
                                      {isEditorActive() ? (
                                        <Link
                                          field={item.fields.ReadMoreLink}
                                        />
                                      ) : (
                                        <Link
                                          field={{
                                            value:
                                              item.fields.ReadMoreLink?.value
                                                ?.href,
                                          }}
                                          href={anchorWithId(
                                            item.fields.ReadMoreLink?.value
                                              ?.href,
                                            item.fields.ReadMoreLink?.value
                                              ?.anchor
                                          )}
                                          target={
                                            item?.fields?.linktarget?.value &&
                                            item?.fields?.linktarget?.value !==
                                              ''
                                              ? item?.fields?.linktarget?.value
                                              : '_blank'
                                          }
                                        >
                                          <Text
                                            field={{
                                              value:
                                                item.fields.ReadMoreLink?.value
                                                  .text,
                                            }}
                                            tag="span"
                                          />
                                          <span className="link-with-arrow link-with-arrow--text">
                                            <pfe-icon
                                              icon="cnh-arrow-forward"
                                              size={'24'}
                                              color={'complement'}
                                            />
                                          </span>
                                        </Link>
                                      )}
                                    </p>
                                  ) : null}
                                  {/* WEBCAST LINK */}
                                  {item?.fields?.WebCastLink?.value.href ? (
                                    <p className="link">
                                      {isEditorActive() ? (
                                        <Link
                                          field={item.fields.WebCastLink}
                                        />
                                      ) : (
                                        <Link
                                          field={{
                                            value:
                                              item.fields.WebCastLink?.value
                                                ?.href,
                                          }}
                                          href={anchorWithId(
                                            item.fields.WebCastLink?.value
                                              ?.href,
                                            item.fields.WebCastLink?.value
                                              ?.anchor
                                          )}
                                          rel="noopener noreferrer"
                                          target={
                                            item?.fields?.linktarget?.value &&
                                            item?.fields?.linktarget?.value !==
                                              ''
                                              ? item?.fields?.linktarget?.value
                                              : '_blank'
                                          }
                                        >
                                          <Text
                                            field={{
                                              value:
                                                item.fields.WebCastLink?.value
                                                  .text,
                                            }}
                                            tag="span"
                                          />
                                          <span className="link-with-arrow link-with-arrow--text">
                                            <pfe-icon
                                              icon="cnh-external-link"
                                              size={'24'}
                                              color={'complement'}
                                            />
                                          </span>
                                        </Link>
                                      )}
                                    </p>
                                  ) : null}
                                  {/* {item.fields.DocumentLink?.value?.src ? (
                                    <>
                                      {isEditorActive() ? (
                                        <Link
                                          field={item.fields?.DocumentLink}
                                        />
                                      ) : (
                                        <div className="PDF-File">
                                          <Text
                                            className="file-size"
                                            field={{
                                              value: convertFileSize(
                                                item.fields?.DocumentLink?.value
                                                  ?.size
                                              ),
                                            }}
                                            tag="p"
                                          />
                                          <p className="link">
                                            <Link
                                              target={
                                                item?.fields?.linktarget
                                                  ?.value &&
                                                item?.fields?.linktarget
                                                  ?.value !== ""
                                                  ? item?.fields?.linktarget
                                                      ?.value
                                                  : "_blank"
                                              }
                                              field={{
                                                value:
                                                  item.fields?.DocumentLink
                                                    ?.value?.src,
                                              }}
                                              href={anchorWithId(
                                                item.fields?.DocumentLink?.value
                                                  ?.src,
                                                item.fields?.DocumentLink?.value
                                                  ?.anchor
                                              )}
                                            >
                                              <Text
                                                field={{
                                                  value:
                                                    item.fields?.DocumentLink?.value?.extension.toUpperCase(),
                                                }}
                                                tag="span"
                                              />
                                              <span className="link-with-arrow link-with-arrow--text">
                                                <pfe-icon
                                                  icon="cnh-download"
                                                  size={"24"}
                                                  color={"complement"}
                                                />
                                              </span>
                                            </Link>
                                          </p>
                                        </div>
                                      )}
                                    </>
                                  ) : null} */}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              eventListItems?.map((item, index: number) => (
                <div
                  key={index}
                  className={`${
                    index % 2
                      ? 'rte-event-list rte-event-listBKB'
                      : 'rte-event-list rte-event-listBKA'
                  } ${
                    TwoColumns
                      ? 'rte-event-list--split-two'
                      : 'rte-event-list--keep-one'
                  }`}
                >
                  <div className="rte-event-list-right">
                    <div className="rte-event-list-header-wrapper">
                      <div className="rte-event-list-header left">
                        {/* modify with field */}
                        {DateField ||
                          (DateField.length !== 0 && (
                            <div className="rte-event-list-heading-left">
                              {DateField}
                            </div>
                          ))}

                        <RichText
                          field={item.fields?.EventTitle}
                          className="rte-event-list-heading"
                          tag="h3"
                        />
                      </div>
                      <div
                        className={`rte-event-list-header right ${
                          item?.fields?.EventPage?.value.href ||
                          item.fields?.DocumentLink?.value?.src
                            ? ''
                            : 'hideEventHeader'
                        }`}
                      >
                        {/* modify with field */}
                        {(item?.fields?.[`${LinkFieldPDF}`]?.value.href && //adjust search with new fields
                          item.fields[`${LinkFieldPDF}`]?.value.href?.length !==
                            0 &&
                          ((item.fields?.DocumentLink?.value?.extension &&
                            item.fields?.DocumentLink?.value?.extension
                              .length !== 0) ||
                            (PDFIcon && PDFIcon.length !== 0))) ||
                          (item.fields?.[`${LinkFieldIMG}`]?.value.href &&
                            item.fields[`${LinkFieldIMG}`]?.value.href?.length !== 0 &&
                            ((item.fields?.DocumentLink?.value?.extension &&
                              item.fields?.DocumentLink?.value?.extension
                                .length !== 0) ||
                              (IMGIcon && IMGIcon.length !== 0))) ||
                          (item?.fields?.[`${LinkFieldZIP}`]?.value.href &&
                            item.fields[`${LinkFieldZIP}`]?.value.href?.length !== 0 &&
                            ((item.fields?.DocumentLink?.value?.extension &&
                              item.fields?.DocumentLink?.value?.extension
                                .length !== 0) ||
                              (ZIPIcon && ZIPIcon.length !== 0)) && (
                              <div
                                className={` ${
                                  TwoColumns
                                    ? 'rte-event-list-heading-grandfather rte-event-list-heading-grandfather-twoc'
                                    : 'rte-event-list-heading-grandfather'
                                }`}
                              >
                                {item.fields[`${LinkFieldPDF}`]?.value.href &&
                                  item.fields[`${LinkFieldPDF}`]?.value.href?.length !== 0 && (
                                    <div
                                      className={`rte-event-list-heading-father ${
                                        IsPDFIcon &&
                                        'rte-event-list-heading-father--icon'
                                      }`}
                                    >
                                      <a
                                        className="rte-event-list-heading-left"
                                        download
                                        href={anchorWithId(
                                          item.fields?.[`${LinkFieldPDF}`]?.value?.href ?? '',
                                          item.fields[`${LinkFieldPDF}`]?.value
                                            .anchor
                                        )}
                                        target={
                                          item.fields[`${LinkFieldPDF}`]?.value
                                            ?.target &&
                                          item.fields[`${LinkFieldPDF}`]?.value
                                            ?.target !== ''
                                            ? item.fields[`${LinkFieldPDF}`]
                                                ?.value?.target
                                            : '_blank'
                                        }
                                      >
                                        {IsPDFIcon ? (
                                          <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                            <pfe-icon
                                              icon={PDFIcon}
                                              size={'24'}
                                              color={'complement'}
                                            />
                                          </span>
                                        ) : (
                                          <Text
                                            field={{
                                              value:
                                                item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldPDF}`])
                                            }}
                                            tag="p"
                                            className="rte-event-list-heading-left"
                                          />
                                        )}
                                      </a>
                                      <Text
                                        field={{
                                          value: convertFileSize(
                                            item.fields?.DocumentLink?.value
                                              ?.size // field ([`${LinkFieldPDF}`])
                                          ),
                                        }}
                                        tag="p"
                                        className="rte-event-list-heading-left"
                                      />
                                    </div>
                                  )}

                                {item.fields[`${LinkFieldIMG}`]?.value.href &&
                                  item.fields[`${LinkFieldIMG}`]?.value.href?.length !== 0 && (
                                    <div
                                      className={`rte-event-list-heading-father ${
                                        IsIMGIcon &&
                                        'rte-event-list-heading-father--icon'
                                      }`}
                                    >
                                      <a
                                        className="rte-event-list-heading-left"
                                        download
                                        href={anchorWithId(
                                          item.fields[`${LinkFieldIMG}`]?.value?.href ?? '',
                                          item.fields[`${LinkFieldIMG}`]?.value
                                            .anchor
                                        )}
                                        target={
                                          item.fields[`${LinkFieldIMG}`]?.value
                                            ?.target &&
                                          item.fields[`${LinkFieldIMG}`]?.value
                                            ?.target !== ''
                                            ? item.fields[`${LinkFieldIMG}`]
                                                ?.value?.target
                                            : '_blank'
                                        }
                                      >
                                        {IsIMGIcon ? (
                                          <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                            <pfe-icon
                                              icon={IMGIcon}
                                              size={'24'}
                                              color={'complement'}
                                            />
                                          </span>
                                        ) : (
                                          <Text
                                            field={{
                                              value:
                                                item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldIMG}`])
                                            }}
                                            tag="p"
                                            className="rte-event-list-heading-left"
                                          />
                                        )}
                                      </a>
                                      <Text
                                        field={{
                                          value: convertFileSize(
                                            item.fields?.DocumentLink?.value
                                              ?.size // field ([`${LinkFieldIMG}`])
                                          ),
                                        }}
                                        tag="p"
                                        className="rte-event-list-heading-left"
                                      />
                                    </div>
                                  )}

                                {item.fields[`${LinkFieldZIP}`]?.value.href &&
                                  item.fields[`${LinkFieldZIP}`]?.value.href?.length !== 0 && (
                                    <div
                                      className={`rte-event-list-heading-father ${
                                        IsZIPIcon &&
                                        'rte-event-list-heading-father--icon'
                                      }`}
                                    >
                                      <a
                                        className="rte-event-list-heading-left"
                                        download
                                        href={anchorWithId(
                                          item.fields[`${LinkFieldZIP}`]?.value?.href ?? '',
                                          item.fields[`${LinkFieldZIP}`]?.value
                                            .anchor
                                        )}
                                        target={
                                          item.fields[`${LinkFieldZIP}`]?.value
                                            ?.target &&
                                          item.fields[`${LinkFieldZIP}`]?.value
                                            ?.target !== ''
                                            ? item.fields[`${LinkFieldZIP}`]
                                                ?.value?.target
                                            : '_blank'
                                        }
                                      >
                                        {IsZIPIcon ? (
                                          <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left">
                                            <pfe-icon
                                              icon={ZIPIcon}
                                              size={'24'}
                                              color={'complement'}
                                            />
                                          </span>
                                        ) : (
                                          <Text
                                            field={{
                                              value:
                                                item.fields?.DocumentLink?.value?.extension.toUpperCase(), // field ([`${LinkFieldZIP}`])
                                            }}
                                            tag="p"
                                            className="rte-event-list-heading-left"
                                          />
                                        )}
                                      </a>
                                      <Text
                                        field={{
                                          value: convertFileSize(
                                            item.fields?.DocumentLink?.value
                                              ?.size // field ([`${LinkFieldZIP}`])
                                          ),
                                        }}
                                        tag="p"
                                        className="rte-event-list-heading-left"
                                      />
                                    </div>
                                  )}
                              </div>
                            ))}

                        {item?.fields?.EventPage?.value.href ? (
                          <p className="read-more-link">
                            {isEditorActive() ? (
                              <Link
                                field={item.fields.EventPage}
                              />
                            ) : (
                              <Link
                                field={{
                                  value: item.fields.EventPage?.value?.href,
                                }}
                                href={anchorWithId(
                                  item.fields.EventPage?.value?.href,
                                  item.fields.EventPage?.value?.anchor
                                )}
                                target={
                                  item?.fields?.linktarget?.value &&
                                  item?.fields?.linktarget?.value !== ''
                                    ? item?.fields?.linktarget?.value
                                    : '_blank'
                                }
                              >
                                <Text
                                  field={{
                                    value: item.fields.EventPage?.value.text,
                                  }}
                                  tag="span"
                                />
                                <span className="link-with-arrow link-with-arrow--text">
                                  <pfe-icon
                                    icon="cnh-arrow-forward"
                                    size={'24'}
                                    color={'complement'}
                                  />
                                </span>
                              </Link>
                            )}
                          </p>
                        ) : null}

                        {/* {item.fields.DocumentLink?.value?.src ? (
                          <>
                            {isEditorActive() ? (
                              <Link
                                field={item.fields?.DocumentLink}
                              />
                            ) : (
                              <div className="PDF-File">
                                <Text
                                  className="file-size"
                                  field={{
                                    value: convertFileSize(
                                      item.fields?.DocumentLink?.value?.size
                                    ),
                                  }}
                                  tag="p"
                                />
                                <p className="link">
                                  <Link
                                    target={
                                      item?.fields?.linktarget?.value &&
                                      item?.fields?.linktarget?.value !== ""
                                        ? item?.fields?.linktarget?.value
                                        : "_blank"
                                    }
                                    field={{
                                      value:
                                        item.fields?.DocumentLink?.value?.src,
                                    }}
                                    href={anchorWithId(
                                      item.fields?.DocumentLink?.value?.src,
                                      item.fields?.DocumentLink?.value?.anchor
                                    )}
                                  >
                                    <Text
                                      field={{
                                        value:
                                          item.fields?.DocumentLink?.value?.extension.toUpperCase(),
                                      }}
                                      tag="span"
                                    />
                                    <span className="link-with-arrow link-with-arrow--text">
                                      <pfe-icon
                                        icon="cnh-download"
                                        size={"24"}
                                        color={"complement"}
                                      />
                                    </span>
                                  </Link>
                                </p>
                              </div>
                            )}
                          </>
                        ) : null} */}
                      </div>
                    </div>
                    {(item?.fields?.Events?.length ?? 0)> 0 && (
                      <div className="rte-event-list-container">
                        {item.fields?.Events?.map((item, index: number) => (
                          <div className="rte-event-list-row" key={index}>
                            <div className={`rte-event-list-column left `}>
                              <RichText field={item.fields?.Name} tag="span" />
                            </div>

                            {/* READ MORE LINK */}
                            <div className="rte-event-list-column right">
                              {item.fields?.ReadMoreLink?.value.href ? (
                                <p className="read-more-link">
                                  {isEditorActive() ? (
                                    <Link
                                      field={item.fields.ReadMoreLink}
                                    />
                                  ) : (
                                    <Link
                                      field={{
                                        value:
                                          item.fields.ReadMoreLink?.value?.href,
                                      }}
                                      href={anchorWithId(
                                        item.fields.ReadMoreLink?.value?.href,
                                        item.fields.ReadMoreLink?.value?.anchor
                                      )}
                                      target={
                                        item?.fields?.linktarget?.value &&
                                        item?.fields?.linktarget?.value !== ''
                                          ? item?.fields?.linktarget?.value
                                          : '_blank'
                                      }
                                    >
                                      <Text
                                        field={{
                                          value:
                                            item.fields.ReadMoreLink?.value
                                              .text,
                                        }}
                                        tag="span"
                                      />
                                      <span className="link-with-arrow link-with-arrow--text">
                                        <pfe-icon
                                          icon="cnh-arrow-forward"
                                          size={'24'}
                                          color={'complement'}
                                        />
                                      </span>
                                    </Link>
                                  )}
                                </p>
                              ) : null}
                              {/* WEBCAST LINK */}
                              {item?.fields?.WebCastLink?.value.href ? (
                                <p className="link">
                                  {isEditorActive() ? (
                                    <Link
                                      field={item.fields.WebCastLink}
                                    />
                                  ) : (
                                    <Link
                                      field={{
                                        value:
                                          item.fields.WebCastLink?.value?.href,
                                      }}
                                      href={anchorWithId(
                                        item.fields.WebCastLink?.value?.href,
                                        item.fields.WebCastLink?.value?.anchor
                                      )}
                                      rel="noopener noreferrer"
                                      target={
                                        item?.fields?.linktarget?.value &&
                                        item?.fields?.linktarget?.value !== ''
                                          ? item?.fields?.linktarget?.value
                                          : '_blank'
                                      }
                                    >
                                      <Text
                                        field={{
                                          value:
                                            item.fields.WebCastLink?.value.text,
                                        }}
                                        tag="span"
                                      />
                                      <span className="link-with-arrow link-with-arrow--text">
                                        <pfe-icon
                                          icon="cnh-external-link"
                                          size={'24'}
                                          color={'complement'}
                                        />
                                      </span>
                                    </Link>
                                  )}
                                </p>
                              ) : null}
                              {/* {item.fields.DocumentLink?.value?.src ? (
                                <>
                                  {isEditorActive() ? (
                                    <Link
                                      field={item.fields?.DocumentLink}
                                    />
                                  ) : (
                                    <div className="PDF-File">
                                      <Text
                                        className="file-size"
                                        field={{
                                          value: convertFileSize(
                                            item.fields?.DocumentLink?.value
                                              ?.size
                                          ),
                                        }}
                                        tag="p"
                                      />
                                      <p className="link">
                                        <Link
                                          target={
                                            item?.fields?.linktarget?.value &&
                                            item?.fields?.linktarget?.value !==
                                              ""
                                              ? item?.fields?.linktarget?.value
                                              : "_blank"
                                          }
                                          field={{
                                            value:
                                              item.fields?.DocumentLink?.value
                                                ?.src,
                                          }}
                                          href={anchorWithId(
                                            item.fields?.DocumentLink?.value
                                              ?.src,
                                            item.fields?.DocumentLink?.value
                                              ?.anchor
                                          )}
                                        >
                                          <Text
                                            field={{
                                              value:
                                                item.fields?.DocumentLink?.value?.extension.toUpperCase(),
                                            }}
                                            tag="span"
                                          />
                                          <span className="link-with-arrow link-with-arrow--text">
                                            <pfe-icon
                                              icon="cnh-download"
                                              size={"24"}
                                              color={"complement"}
                                            />
                                          </span>
                                        </Link>
                                      </p>
                                    </div>
                                  )}
                                </>
                              ) : null} */}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default withSitecoreContext()(Events)
